<template>
  <div class="flex items-center">
    <label
      v-if="label"
      class="form-label mr-2 pt-1"
      :for="id">{{ label }}:</label>
    <div @click="toggle" class="bg-gray-200 rounded-full w-12 h-6 relative">
      <div
        :class="[
          isOn ? 'transform bg-green-500 translate-x-6' : 'bg-gray-500',
          'rounded-full w-6 h-6 absolute top-0 left-0 transition duration-300',
        ]" />
    </div>
    <span class="ml-2 text-gray-700">{{ isOn ? "ON" : "OFF" }}</span>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default () {
        return `toggle-input-${this._uid}`
      },
    },
    label: String,
    value: {
     type: Boolean,
     default: false,
    },
  },
  data () {
    return {
      isOn: this.value, // Status awal tombol
    }
  },
  methods: {
    toggle () {
      this.isOn = !this.isOn
      this.$emit('input', this.isOn) // Emit event ketika status berubah
    },
  },
}
</script>
